const contenCard = [
  {
    id: 1,
    heading: "Bamboo Stand",
    topRight: "Pledge $25 or more",
    text: "You get an ergonomic stand made of natural bamboo. You've helped us launch our promotional campaign, and you’ll be added to a special Backer member list.",
    left: "101",
    amt: "25",
    disable: false,
  },
  {
    id: 2,
    heading: "Black Edition Stand",
    topRight: "Pledge $75 or more",
    text: "You get a Black Special Edition computer stand and a personal thank you. You’ll be added to our Backer member list. Shipping is included.",
    left: "64",
    amt: "75",
    disable: false,
  },
  {
    id: 3,
    heading: "Mahogany Special Edition",
    topRight: "Pledge $200 or more",
    text: "You get two Special Edition Mahogany stands, a Backer T-Shirt, and a personal thank you. You’ll be added to our Backer member list. Shipping is included.",
    left: "0",
    amt: "200",
    disable: true,
  },
];
export { contenCard as default };
